import { QueryOperators } from '../models/DocumentFilterAttribute';

export const  queryOperators = {
    reference: [
      {
        name: '=',
        value: QueryOperators.Eq
      }
    ],
    string: [
      {
        name: '',
        value: null
      },
      {
        name: '=',
        value: QueryOperators.Eq
      },
      {
        name: '<=',
        value: QueryOperators.Lte
      },
      {
        name: '>=',
        value: QueryOperators.Gte
      },
      {
        name: 'Vsebuje',
        value: QueryOperators.In
      },
      {
        name: 'Območje',
        value: QueryOperators.Range
      },
    ],
    time: [
      {
        name: '',
        value: null
      },
      {
        name: '=',
        value: QueryOperators.Eq
      },
      {
        name: '<=',
        value: QueryOperators.Lte
      },
      {
        name: '>=',
        value: QueryOperators.Gte
      },
      {
        name: 'Območje',
        value: QueryOperators.Range
      }
    ],
    number: [
      {
        name: '',
        value: null
      },
      {
        name: '=',
        value: QueryOperators.Eq
      },
      {
        name: '<',
        value: QueryOperators.Lt
      },
      {
        name: '>',
        value: QueryOperators.Gt
      },
      {
        name: '<=',
        value: QueryOperators.Lte
      },
      {
        name: '>=',
        value: QueryOperators.Gte
      },
      {
        name: 'Območje',
        value: QueryOperators.Range
      }
    ],
    date: [
      {
        name: '',
        value: null
      },
      {
        name: '=',
        value: QueryOperators.Eq
      },
      {
        name: '<=',
        value: QueryOperators.Lte
      },
      {
        name: '>=',
        value: QueryOperators.Gte
      },
      {
        name: 'Območje',
        value: QueryOperators.Range
      }
    ],
    dateTime: [
      {
        name: '',
        value: null
      },
      {
        name: '=',
        value: QueryOperators.Eq
      },
      {
        name: '<=',
        value: QueryOperators.Lte
      },
      {
        name: '>=',
        value: QueryOperators.Gte
      },
      {
        name: 'Območje',
        value: QueryOperators.Range
      }
    ]
  };
